<!-- 기본 레이아웃 (헤더 포함) -->
<div class="flex flex-col min-h-screen bg-white">
  <!-- FOMO 상단 고정 배너 (홈 화면 전용) -->
  @if (isHomePage()) {
    <app-fomo-top-banner />
    <!-- fixed 요소 높이 보정 spacer (40px) -->
    <div class="h-10 shrink-0"></div>
  }

  <!-- PC 헤더 (mobileHeader가 있는 페이지면 md 이상에서만 표시) -->
  @if (hasMobileHeader()) {
    <app-header class="hidden md:block sticky z-50" [class]="headerTopClass()" />
  } @else {
    <app-header class="sticky z-50" [class]="headerTopClass()" />
  }

  <!-- 메인 콘텐츠 -->
  <!-- 모바일: 기존 그대로 / PC: max-w-[1200px] 제한 -->
  <main class="flex-1 flex flex-col bg-white md:max-w-[1200px] md:w-full md:mx-auto">
    <router-outlet />
  </main>

  <!-- PC 푸터 (md 이상) -->
  <app-footer class="hidden md:block" />

  <!-- 팝업 배너 (홈 화면 전용) -->
  @if (isHomePage()) {
    <app-popup-banner />
  }

  <!-- FOMO 하단 고정 바 (홈 화면 전용) -->
  @if (isHomePage()) {
    <app-fomo-bottom-bar />
  }
</div>
